import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  SyntheticEvent,
} from "react";
import { StyleSettings } from "src/styles/StyleSettings";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { IconButton } from "@mui/material";
import SnGrid from "@shared/components/Grid/SnGrid";
import { getTablebySql } from "@shared/utils/CommonUtils";
import SnTab from "@shared/components/SnTab";
import { Box, TextField, Typography } from "@mui/material";
import SnButton from "@shared/components/SnButton";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Props {
  type: string;
  columnsData: any[];
  gridData: any;
  modalRef?: any; // 부모 엘리먼트
  isPopup?: boolean;
}

const DesignerGridEdit = forwardRef(
  (
    {
      type,
      columnsData,
      gridData = {
        title: "",
        table: "",
        button: "",
        buttonNode: null,
      },
      modalRef,
      isPopup,
    }: Props,
    ref
  ) => {
    const gridApiRef = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const { userInfo } = global();
    const [girdcolumns, setGridColumns] = useState<any[]>([]);
    const parentref = modalRef.current.getPopupParent();
    const selectedTabPage = useRef<any>(1);
    const [form, setForm] = useState(gridData);
    const [options, setOptions] = useState<any[]>(gridData.columnsInfo || []);
    const [initOption, setInitOption] = useState<any[]>(
      gridData.filterColumns || []
    );

    useEffect(() => {
      const fetchform = async () => {
        try {
          let rtn: any[] = [];
          if (type === "조회조건" || type === "프리폼" || type === "쉐어드폼") {
            rtn = await getTablebySql({
              sql: "select * from sys_formgridcolumn where cd_firm = '1000' and cd_menu = 'SN_SYS_BAS_REG_006' order by no_seq",
            });
            const columns: string[] = [
              "cd_menu",
              "cd_form",
              "no_line",
              "fg_visible",
            ];
            rtn = rtn.map((row) => {
              if (columns.includes(row.cd_column)) {
                return { ...row, fg_visible: "N" };
              }
              return row;
            });
          } else if (type === "그리드") {
            rtn = await getTablebySql({
              sql: "select * from sys_formgridcolumn where cd_firm = '1000' and cd_menu = 'SN_SYS_BAS_REG_007' order by no_seq",
            });
            const columns: string[] = ["cd_menu", "cd_grid", "fg_visible"];

            rtn = rtn.flatMap((row) => {
              if (columns.includes(row.cd_column)) {
                return { ...row, fg_visible: "N" };
              }
              if (row.cd_column === "cd_column") {
                return [
                  row, // 원본 유지
                  {
                    ...row,
                    nm_column: "기본값",
                    no_seq: 10,
                    cd_column: "defaultValue",
                    qt_width: 100,
                    yn_required: "N",
                  },
                ];
              }
              if (row.no_seq > 8) {
                return { ...row, no_seq: row.no_seq + 2 };
              }

              return row;
            });
          }
          setGridColumns(rtn);
        } catch (error) {}
      };
      fetchform();
    }, [type]);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => {
        const button = convertButton(form.button); // 버튼 변환
        return [
          gridApiRef.current?.getRowData(),
          { ...form, buttonNode: button },
        ];
      },
    }));

    const onGridBtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };
    const onAddRow = async () => {
      try {
        const newRow = {}; // 빈 객체
        gridApiRef.current?.addRow(newRow);
      } catch (error: any) {}
    };

    const onDeleteRow = async () => {
      if (gridApiRef.current?.api?.getDisplayedRowCount() < 1) {
        return;
      }
      gridApiRef.current?.deleteSelectedRows();
    };

    const search = async (value: string) => {
      if (type === "조회조건") {
        let id;
        if (isPopup) {
          id = "com_drawing_02";
        } else {
          id = "com_drawing_04";
        }
        const param = {
          id: "com_drawing_02",
          params: {
            cd_firm: userInfo.cd_firm,
            nm_label: value,
          },
        };
        const rtn: any = await fnGetDataSet(param);
        gridApiRef.current?.addRow(rtn[0][0]);
      } else if (type === "그리드") {
        let id;
        if (isPopup) {
          id = "com_drawing_01";
        } else {
          id = "com_drawing_03";
        }
        const param = {
          id: "com_drawing_01",
          params: {
            cd_firm: userInfo.cd_firm,
            nm_column: value,
          },
        };

        const rtn: any = await fnGetDataSet(param);
        gridApiRef.current?.addRow(rtn[0][0]);
      } else if (type === "프리폼" || type === "쉐어드폼") {
        let id;
        if (isPopup) {
          id = "com_drawing_06";
        } else {
          id = "com_drawing_05";
        }
        const param = {
          id: "com_drawing_05",
          params: {
            cd_firm: userInfo.cd_firm,
            nm_label: value,
          },
        };
        const rtn: any = await fnGetDataSet(param);
        gridApiRef.current?.addRow(rtn[0][0]);
      }
    };

    const handleChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };

    const onGridBtnClick = (key: string) => {
      if (key.includes("적용")) {
      } else alert(key);
    };

    const convertButton = (value: string) => {
      if (value == null || value == "") return null;
      const buttonLabels = value
        .split(",")
        .map((label) => label.trim())
        .filter((label) => label);

      const nodes = buttonLabels.map((label) => (
        <SnButton
          key={label}
          text={label}
          onClick={() => onGridBtnClick(label)}
        />
      ));
      return nodes;
    };

    const convertDefaultValue = (str: string) => {
      return str
        .split(",")
        .map((pair) => pair.trim())
        .filter(Boolean)
        .reduce(
          (acc, cur) => {
            const [key, value] = cur.split(":").map((s) => s.trim());
            if (key) acc[key] = value ?? "";
            return acc;
          },
          {} as Record<string, string>
        );
    };
    const setColumnsInfo = async () => {
      const columnsInfo = await getColumnsInfo(form.table);
      setForm({ ...form, columnsInfo: columnsInfo });
      if (columnsInfo && Array.isArray(columnsInfo)) {
        setOptions(columnsInfo);
      }
    };

    const getColumnsInfo = async (tablename: string) => {
      try {
        const rtn: any[] = await getTablebySql({
          sql: `SELECT
                      col.column_name,
                      col.data_type,
                      col.character_maximum_length,
                      col.numeric_precision,
                      col.numeric_scale,
                      col.is_nullable,
                      col.column_default,
                      CASE WHEN pk.column_name IS NOT NULL THEN 'YES' ELSE 'NO' END AS is_primary_key
                  FROM information_schema.columns col
                  LEFT JOIN (
                      SELECT 
                          kcu.column_name
                      FROM 
                          information_schema.table_constraints tc
                      JOIN information_schema.key_column_usage kcu 
                          ON tc.constraint_name = kcu.constraint_name
                          AND tc.table_name = kcu.table_name
                      WHERE tc.constraint_type = 'PRIMARY KEY'
                        AND tc.table_name = '${tablename}'
                        AND tc.table_schema = 'snotes'
                  ) pk
                      ON col.column_name = pk.column_name
                  WHERE col.table_name = '${tablename}'
                    AND col.table_schema = 'snotes'
                  ORDER BY col.ordinal_position;`,
        });
        return rtn;
      } catch (error) {}
    };

    const onTabChanged = (tabIndex: any) => {
      selectedTabPage.current = tabIndex;
    };

    const filterChange = (e: SyntheticEvent, value: any) => {
      const filterColumns = value.map((option: any) => option.column_name);
      setForm({ ...form, filterColumns: filterColumns });
      setInitOption(filterColumns);
    };

    return (
      <div>
        <SnTab
          titles={
            type === "그리드" || type === "프리폼"
              ? ["컬럼", "그리드"]
              : ["컨트롤"]
          }
          width={"100%"}
          onTabChanged={onTabChanged}
          body={[
            <div>
              <div className="w-[1438px] h-[600px]">
                <SnGrid
                  ref={gridApiRef} // Grid Name
                  enableAddRow={true}
                  isEditable={true}
                  columnConfig={girdcolumns} // 컬럼 설정 전달
                  rowData={
                    columnsData.length === 1 &&
                    Object.keys(columnsData[0]).length === 0
                      ? []
                      : columnsData
                  }
                  onBtnAddClick={onGridBtnsClick}
                  onBtnDeleteClick={onGridBtnsClick}
                  rowSelection="single" // 단일 선택 모드
                  title=""
                  popupParent={parentref} // 부모 엘리먼트 전달
                />
              </div>
            </div>,
            <div>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 2,
                  p: 2,
                  border: "1px solid rgb(186,191,199)",
                  height: "100%",
                }}
              >
                <Typography sx={{ alignSelf: "center" }}>타이틀</Typography>
                <TextField
                  size="small"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  fullWidth
                />

                <Typography sx={{ alignSelf: "center" }}>저장테이블</Typography>
                <TextField
                  size="small"
                  name="table"
                  value={form.table}
                  onChange={handleChange}
                  onBlur={() => {
                    setColumnsInfo();
                  }}
                  fullWidth
                />

                <Typography sx={{ alignSelf: "start", mt: 1 }}>
                  필터링
                </Typography>
                <Autocomplete
                  size="small"
                  multiple
                  options={options}
                  disableCloseOnSelect
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : (option?.column_name ?? "")
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.column_name === value.column_name
                  }
                  value={options.filter((option: any) =>
                    initOption.includes(option.column_name)
                  )}
                  onChange={filterChange}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.column_name}
                      </li>
                    );
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Columns" />
                  )}
                />

                <Typography sx={{ alignSelf: "start", mt: 1 }}>버튼</Typography>
                <TextField
                  name="button"
                  value={form.button}
                  onChange={handleChange}
                  multiline
                  minRows={15}
                  fullWidth
                />
                {/* 빈 칸 채우기 */}
                <Box />
              </Box>
            </div>,
          ]}
          header={[
            <div ref={parentref} className="flex items-center justify-between">
              {/* 좌측: 검색 및 SnTextBox */}
              <div className="flex items-center">
                <span className="mr-8">검 색</span>
                <div className="w-[300px]">
                  <TextField
                    fullWidth
                    slotProps={{
                      input: {
                        autoComplete: "off",
                        style: {
                          height: StyleSettings.control_height,
                          fontSize: StyleSettings.font,
                        },
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        search((e.target as HTMLInputElement).value);
                      }
                    }}
                  />
                </div>
              </div>
              {/* 우측: IconButton들 */}
              <div className="flex items-center">
                <div className="ml-2">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("addRow");
                    }}
                    sx={{
                      backgroundImage: "url(/images/new_off.svg)",
                      backgroundSize: "cover",
                      width: 30,
                      height: 30,
                      "&:hover": {
                        backgroundImage: "url(/images/new_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
                <div className="ml-5 mr-4">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("deleteRow");
                    }}
                    sx={{
                      backgroundImage: "url(/images/delete_off.svg)",
                      backgroundSize: "cover",
                      width: 25,
                      height: 25,
                      "&:hover": {
                        backgroundImage: "url(/images/delete_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
              </div>
            </div>,
            null,
          ]}
        />
      </div>
    );
  }
);

export default DesignerGridEdit;
